<template>
    <section class="page-header">
        <div class="steps">
            <div v-for="step in steps" class="item"
                 :class="{ active : isCurrentStep(step), done : isFinishedStep(step) }">
                <span v-if="!isFinishedStep(step)">{{ step.number }}</span>
                <span v-else>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64"
                         enable-background="new 0 0 64 64" xml:space="preserve">
                      <path fill="#ffffff" d="M31.051,51c-1.197,0-2.397-0.428-3.354-1.293l-20.9-18.917c-2.047-1.853-2.205-5.015-0.352-7.062 c1.854-2.049,5.015-2.206,7.062-0.352l17.24,15.604l22.631-24.383c1.88-2.023,5.042-2.141,7.066-0.262 c2.023,1.879,2.141,5.042,0.262,7.066l-25.998,28C33.729,50.462,32.394,51,31.051,51z"></path>
                    </svg>
                </span>
                <div>
                    <h3>{{ step.title }}</h3>
                    <p>{{ step.description }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'CartSteps',
        props: ['currentStep'],
        data: function () {
            return {
                steps: [
                    {
                        number: 1,
                        title: 'Корзина',
                        description: 'Убедитесь в правильном выборе',
                    },
                    {
                        number: 2,
                        title: 'Доставка и оплата',
                        description: 'Выбирете способ доставки и оплаты',
                    },
                    {
                        number: 3,
                        title: 'Оформление',
                        description: 'Введите контактные данные',
                    },
                ]
            };
        },
        methods: {
            isCurrentStep (step) {
                return step.number === this.currentStep;
            },

            isFinishedStep (step) {
                return step.number < this.currentStep;
            }
        }
    }
</script>